<template>
	<div class="main-content" v-loading="loading">
		<div class="user-address" v-if="!loading">
			<div class="mt50">
				<div class="order-table table-heard" style="margin-bottom: 0;">
					<!-- <div style="width: 100px;text-align: center;">选择地址</div> -->
					<div class="order-th">联系人</div>
					<div class="order-th">联系电话</div>
					<div class="order-th">所在地区</div>
					<!-- <div class="order-th">详细地址</div> -->
				</div>

				<div class="order-item" v-if="list.length>0">
					<div class="order-table" v-for="(item,index) in list">
						<!-- <div style="width: 100px;text-align: center;" @click="selectAddress(index)">
							<span class="iconfont iconxuanzhong" v-if="selectDdata.id==item.id"></span>
							<span class="iconfont iconweibiaoti38" v-else></span>
							 </div> -->
						<div class="order-th">{{item.name}}</div>
						<div class="order-th">{{item.tel}}</div>
						<div class="order-th">{{item.address}}</div>
					</div>
				</div>
				<div class="empty-data" v-if="list.length==0" >
					--暂无数据--
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'user-address',
		data() {
			return {
				loading: true,
				list: []
			}
		},
		created: function() {
			this.selectDdata = this.$store.state.address;
			this.reload();
		},
		methods: {
			reload: function() {
				this.https.fetchGet('/pc/service/trade/address/index')
					.then((res) => {
						if (res.data.success) {
							var data = res.data.content;
							this.list = data.rows;
							this.loading = false;
						}

					}).catch(err => {
						console.log(err)
					})
			},
			selectAddress: function(index) {
				this.$store.dispatch('selectAddressFun', this.list[index])
				if(this.$route.query.source=='1'){
					this.$store.dispatch('modifyAddressFun', true)
				}
				this.$router.go(-1); //返回上一层
			}
		}
	};
</script>

<style scoped="">
	.user-address {
		padding: 100px 200px;
	}

	.iconxuanzhong {
		color: red;
		font-size: 24px;
		cursor: pointer;
	}
	.iconweibiaoti38 {
		font-size: 20px;
		cursor: pointer;
	}
	.empty-data {
		text-align: center;
		background: #fff;
		padding: 100px;
		color: #999;
	}
</style>



// WEBPACK FOOTER //
// src/views/address.vue